import { AppleLogo, GooglePlayLogo } from "@phosphor-icons/react";
import { STORE_LINKS, isLiveLink } from "@/config/links";
import { useStoreCTA } from "@/components/site/ComingSoon";

const Base = ({ href, testid, icon, top, bottom }) => {
  const { open } = useStoreCTA();
  const handleClick = (e) => {
    if (!isLiveLink(href)) {
      e.preventDefault();
      open();
    }
  };
  return (
    <a
      href={href}
      onClick={handleClick}
      data-testid={testid}
      aria-label={`${top} ${bottom}`}
      className="card-hover-glow group flex items-center gap-3 rounded-xl border border-white/12 bg-white/[0.03] px-5 py-3 text-left hover:bg-white/[0.06]"
    >
      <span className="text-white/90 transition-colors group-hover:text-teal-400">{icon}</span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.16em] text-white/50">{top}</span>
        <span className="font-display text-base font-bold text-white">{bottom}</span>
      </span>
    </a>
  );
};

export const StoreButtons = ({ className = "" }) => (
  <div className={`flex flex-col gap-3 sm:flex-row ${className}`}>
    <Base
      href={STORE_LINKS.appStore}
      testid="cta-app-store"
      icon={<AppleLogo size={28} weight="fill" />}
      top="Download on the"
      bottom="App Store"
    />
    <Base
      href={STORE_LINKS.googlePlay}
      testid="cta-google-play"
      icon={<GooglePlayLogo size={26} weight="fill" />}
      top="Get it on"
      bottom="Google Play"
    />
  </div>
);
